import primaryComponents from "../../../primaryComponents";
import { CustomerSelection } from "./CustomerSelection";
import { useCheckoutCustomer } from "./useCheckoutCustomer";

export const AddCustomerToCheckout = ({ closeModal = () => {} }) => {
  const { customerInfo, setCustomerInfo } = useCheckoutCustomer();

  return (
    <div className="d-flex flex-column p-2" style={{ gap: "15px" }}>
      <h4>Add Customer</h4>

      <CustomerSelection
        customerInfo={customerInfo}
        setCustomerInfo={setCustomerInfo}
      />

      <primaryComponents.Button
        classNames={"btn btn--primary cover mt-3"}
        onClick={() => closeModal()}
      >
        Apply
      </primaryComponents.Button>
    </div>
  );
};
